import { Container } from "./Container";

type PageHeroProps = {
  eyebrow?: string;
  title: string;
  description: string;
};

export function PageHero({ eyebrow, title, description }: PageHeroProps) {
  return (
    <section className="border-b border-line bg-surface">
      <Container className="py-16 md:py-20">
        <div className="max-w-4xl">
          {eyebrow ? (
            <p className="text-sm font-bold uppercase tracking-wide text-mint-dark">{eyebrow}</p>
          ) : null}
          <h1 className="mt-3 text-4xl font-bold md:text-5xl">{title}</h1>
          <p className="mt-5 max-w-3xl text-lg leading-relaxed text-ink-soft">{description}</p>
        </div>
      </Container>
    </section>
  );
}
